"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClickOutside = void 0;

var _react = require("react");

/**
 * Handle clicks outside an element.
 * @returns A ref to pass to the element to handle clicks outside of.
 */
var useClickOutside = function useClickOutside(onClickOutside) {
  var ref = (0, _react.useRef)(null);
  var handleClickOutside = (0, _react.useCallback)(function (evt) {
    var _evt$target, _ref$current;

    var target = evt.target; // The target might be something like an SVG node which doesn't provide
    // the class name as a string.

    var isValidTarget = typeof (evt === null || evt === void 0 ? void 0 : (_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.className) === "string";

    if (!isValidTarget || ref.current && !((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(target)) && ref.current !== target) {
      onClickOutside();
    }
  }, [onClickOutside]);
  (0, _react.useEffect)(function () {
    document.addEventListener("click", handleClickOutside, false);
    return function () {
      return document.removeEventListener("click", handleClickOutside, false);
    };
  }, [handleClickOutside]);
  return ref;
};

exports.useClickOutside = useClickOutside;